module.exports = __webpack_public_path__ + "static/media/now_playing.d17f5cf3.png";